import { render, staticRenderFns } from "./page_search.vue?vue&type=template&id=2d3232ae&scoped=true"
import script from "./page_search.vue?vue&type=script&lang=js"
export * from "./page_search.vue?vue&type=script&lang=js"
import style0 from "./page_search.vue?vue&type=style&index=0&id=2d3232ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3232ae",
  null
  
)

export default component.exports